import Vue from 'vue'
import App from './App.vue'
import ScrollAnimation from './directives/scrollAnimation'
import VueRouter from 'vue-router'
import {routes} from './route'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'babel-polyfill'

Vue.directive('scrollanimation',ScrollAnimation);
Vue.use(VueRouter);
Vue.use(Vuesax);

const router = new VueRouter({
  routes ,
  mode : "history",
  scrollBehavior(to,from,savedPosition){
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve({ x: 100, y: 100 })
    //   }, 3000)
    // })
    if(to.hash)
        {
          return {
            selector: to.hash
            // ,offset:{x:100,y:100}
            
          }
        }
        if(savedPosition){
          return savedPosition
        }else{
          return  { x : 0 , y :0}
        }
    
  }
});

new Vue({
  el: '#app',
  router,
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js